import { CHECKOUT_FORM_NAME } from '../../../constants';
import { PaymentMethodType } from '../../../models/paymentMethods/enums';
import { getCheckoutFormWithErrorsLabel } from '../../../utils/analytics';
import { trackOrderSubmit } from '../../eventAnalytics';
import { getSelectedPaymentMethod } from '../../../selectors/payment';
import {
    isSubmitDisabled,
    getCheckoutFormSectionsWithError,
} from '../../../selectors/forms';
import { submit } from 'redux-form';
import { startApplePaySession } from '../../applePay';

export const handleCheckoutRouting = () => (dispatch, getState) => {
    const selectedPaymentMethod = getSelectedPaymentMethod(getState());
    const formErrors = getCheckoutFormSectionsWithError(
        getState(),
        CHECKOUT_FORM_NAME,
    );
    const trackOrderSubmitLabel =
        getCheckoutFormWithErrorsLabel(formErrors) || selectedPaymentMethod;

    dispatch(trackOrderSubmit(trackOrderSubmitLabel, !!formErrors.length));

    const isCheckoutFormEnabled = !isSubmitDisabled(
        getState(),
        CHECKOUT_FORM_NAME,
    );

    if (
        selectedPaymentMethod === PaymentMethodType.APPLE_PAY &&
        isCheckoutFormEnabled // When there are errors we have to submit the form so Redux-form highlights them
    ) {
        return dispatch(startApplePaySession());
    }

    return dispatch(submit(CHECKOUT_FORM_NAME));
};
